class Notices {
    getNotice(form) {
        return form.querySelector('[data-field="notice"]')
    }

    hideNotices() {
        var notices = document.querySelectorAll('[data-field="notice"]')
        notices.forEach(notice => {
            notice.classList.add('hidden')
        })
    }
    
    showSuccessNotice(notice, success) {
        // console.log(notice, success)
        if (notice) {
            if (notice.hasAttribute('data-hide' && notice.getAttribute('data-hide') == 'success')) return
            notice.classList.remove('hidden')
            notice.setAttribute('data-notice', 'success')
            notice.innerHTML = success
        }
    }
    
    showErrorNotice(notice, error) {
        // console.log(notice, error)
        if (notice) {
            if (notice.hasAttribute('data-hide' && notice.getAttribute('data-hide') == 'error')) return
            notice.classList.remove('hidden')
            notice.setAttribute('data-notice', 'error')
            notice.innerHTML = error
        }
    }
}

export const notices = new Notices()